'use client';

import { Link } from '@coolblue-development/freddy';
import clickReviewsInConfiguratorTrigger from '@coolblue-development/ga4-events/triggers/Configurator/clickReviewsInConfiguratorTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitle } from '@coolblue-development/next-patterns/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { ReviewsDrawer } from '@coolblue-development/next-reviews/client';
import { ReactNode, useState } from 'react';

import { ConfiguratorProduct } from './types';

type Props = {
  product: ConfiguratorProduct;
  salesPriceComponent: ReactNode;
};

export default function ConfiguratorProductSlotReview({ product, salesPriceComponent }: Props) {
  const { trackEvent } = useAnalytics();
  const [showDrawer, setShowDrawer] = useState(false);
  const { language } = useRequestContext();

  const onReviewClick = () => {
    const params = {
      item_id: product.id
    };

    trackEvent(clickReviewsInConfiguratorTrigger(params));
    setShowDrawer(true);
  };

  const productTitleReview = (
    <ProductTitle.Review
      value={product.reviewMetaData?.averageRating || 0}
      reviewCount={product.reviewMetaData?.count}
      showScore={false}
      size='small'
    />
  );

  if (!product.reviewMetaData?.count || product.reviewMetaData?.count === 0) {
    return productTitleReview;
  }

  return (
    <>
      <Link component='button' onClick={onReviewClick}>
        {productTitleReview}
      </Link>
      {showDrawer && (
        <ReviewsDrawer
          productInfo={{
            fullName: product.name,
            url: product.urls?.product || '',
            id: product.id,
            imageId: product.primaryImage?.id || ''
          }}
          lang={language}
          isOpen={showDrawer}
          setIsOpen={setShowDrawer}
          salesPriceComponent={salesPriceComponent}
        />
      )}
    </>
  );
}
